import React, {FC} from 'react'
import {Link} from "react-router-dom";
import {KTIcon} from "../../../../_metronic/helpers";
import {separateFormatter} from "../../../utils/separateFormatter";
import {MyTooltip} from "../tooltip/Tooltip";
import {PLACEHOLDER_IMAGE_URL} from "../../../mock/constants";
import moment from "moment";
import {useIntl} from "react-intl";
import {useDeleteModal} from "../../../context/DeleteModalContext";
import {MODERATOR_COURSE_CATEGORY} from "../../../mock/URLs";
import imgBaseUrl from "../../../utils/imgBaseUrl";
import {ICourseItem} from "../../../types/course";

type CourseCardProps = {
  course: ICourseItem
  refetchCourses?: () => void
}

export const CourseCard: FC<CourseCardProps> = ({course, refetchCourses}) => {
  const {formatMessage} = useIntl()
  const {openDeleteModal} = useDeleteModal()

  const handleDeleteClick = (id: number) => {
    openDeleteModal(MODERATOR_COURSE_CATEGORY, id, refetchCourses);
  };

  return (
      <div>
        <div className="card p-0">
          <div className="card-header p-0">
            <div className="card-img position-relative" style={{
              background: `linear-gradient(45deg, ${course?.first_color}, ${course?.second_color})`
            }}>
              <img src={imgBaseUrl(course?.image) || PLACEHOLDER_IMAGE_URL} alt={course?.title}
                   className="card-img-top img-fluid w-100 h-150px object-fit-cover"/>
              <div>
                <MyTooltip title={formatMessage({id: "Darslar soni"})} position="top">
              <span className="badge badge-light mb-2 position-absolute z-3 top-0 start-0 m-2"><KTIcon
                  iconName={"to-right"}
                  className={"pe-2"}/>{separateFormatter(course?.lesson_count!, " ", "")}</span>
                </MyTooltip>
              </div>
            </div>
          </div>

          <div className="card-body p-3">
            <h5 className="card-title fw-bold text-dark mb-2 text-truncate">{course?.title}</h5>
            <p className="text-muted mb-0 fs-7">{moment(course?.created_at!).format("DD.MM.YYYY HH:mm:ss")}</p>
          </div>


          <div className={"card-footer p-3 d-flex justify-content-between"}>
            <Link to={`/courses/update/${course?.id}`} className={"btn btn-sm btn-light-primary"}>
              <KTIcon iconName={"pencil"} className={"fs-4"}/>
              {formatMessage({id: "Tahrirlash"})}
            </Link>
            <div>
              <MyTooltip title={"Darslarni ko'rish"} position={"top"}>
                <Link to={`/courses/${course?.id}/lesson`}
                      className="btn btn-icon btn-light-warning btn-sm me-1">
                  <KTIcon iconName={"to-right"} className={"pe-0 fs-3"}/>
                </Link>
              </MyTooltip>

              <button className="btn btn-icon btn-danger btn-sm me-1" onClick={() => {
                handleDeleteClick(course.id)
              }}>
                <KTIcon iconName={"trash-square"} className={"pe-0 fs-3"}/>
              </button>
            </div>
          </div>
        </div>
      </div>
  )
}
